import React, { useState } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import logo from '../assets/logo.png';

// Obfuscated email — split to prevent bot scraping
const EMAIL_USER   = 'enquiries';
const EMAIL_DOMAIN = 'aftseniorassistedservices.co.uk';
const EMAIL        = EMAIL_USER + '@' + EMAIL_DOMAIN;

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-2">

          {/* Logo — clicks to go home */}
          <button onClick={() => scrollToSection('home')} className="flex items-center">
            <img
              src={logo}
              alt="AFT Senior Assisted Services"
              className="h-16 sm:h-20 w-auto object-contain"
            />
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('about')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium">
              How It Works
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium">
              Contact
            </button>
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:07475473449" className="flex items-center space-x-1 text-slate-700 hover:text-teal-600 transition-colors text-sm">
              <Phone className="w-4 h-4" />
              <span>07475 473 449</span>
            </a>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-teal-600 hover:bg-teal-700 text-white transition-colors"
            >
              Request Support
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-slate-700 hover:text-teal-600 transition-colors"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-slate-200">
            <nav className="flex flex-col space-y-3">
              <button onClick={() => scrollToSection('home')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium text-left">
                Home
              </button>
              <button onClick={() => scrollToSection('about')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium text-left">
                About
              </button>
              <button onClick={() => scrollToSection('services')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium text-left">
                Services
              </button>
              <button onClick={() => scrollToSection('how-it-works')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium text-left">
                How It Works
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-slate-700 hover:text-teal-600 transition-colors font-medium text-left">
                Contact
              </button>
              <div className="pt-3 border-t border-slate-200">
                <a href="tel:07475473449" className="flex items-center space-x-2 text-slate-700 hover:text-teal-600 transition-colors mb-2">
                  <Phone className="w-4 h-4" />
                  <span>07475 473 449</span>
                </a>
                {/* Email assembled at runtime — not visible to bots scraping HTML */}
                <a href={`mailto:${EMAIL}`} className="flex items-center space-x-2 text-slate-700 hover:text-teal-600 transition-colors">
                  <Mail className="w-4 h-4" />
                  <span className="break-all">{EMAIL}</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;